import Swiper from "swiper";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import Lang from "@vendors-fr/messages";
import {DialogMessage} from "@plugins-fr/dialogMessage";
import {pointProductPopup} from "@commons/userTracks/viewActionName";
import {recordUserViewTrack} from "@commons/userTracks/userTrack";

export function exchangeProductLightbox(productId, standardId, contentLoadedAfter = () => {})
{
    const JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);
    const initSwiperImage = function () {
        const swiper = new Swiper('.swiper_exchange .js_product_images_slider', {
            lazy: true,
        });
        swiper.detachEvents();
    }

    const exchangeDetailAjaxUrl = exchangeDetailUrl + '/' + productId + '/' + standardId;

    $.confirm({
        template: JconfirmTemplateHelper.getTemplate({
            'templateType': '01',
            'theme': 'el_confirm el_popup_view_product'
        }),
        columnClass: 'col-md-10',
        closeIcon: false,
        icon: '',
        title: false,
        content: 'URL:' + exchangeDetailAjaxUrl,
        draggable: false,
        offsetTop: 40,
        offsetBottom: 40,
        buttons: {
            cancelButton: {
                keys: ['esc'],
                text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.close') + '</span>',
                btnClass: 'btn_cancel btn el_btn md solid el_rounded el_text order-1 m-0',
            },
            confirmButton: {
                keys: ['enter'],
                text: '<span class="el_text_inner">'+ Lang.get('frontend.promotionExchange.btn.add') + '</span>',
                btnClass: 'btn_add_exchange btn el_btn md solid el_rounded el_text m-0 js_add_exchange js_confirm js_exchange_standard_id_' + standardId + ' js_exchange_product_id_' + productId,
            }
        },
        onOpenBefore: function () {
            this.$el.find('.js_add_exchange').attr('style', JS_VARS_THEME_STYLE.mainButtonStyle);
            this.$el.find('.js_add_exchange').data('style', JS_VARS_THEME_STYLE.mainButtonStyle);
            this.$el.find('.js_add_exchange').data('hover-style', JS_VARS_THEME_STYLE.mainButtonHoverStyle);

            this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
            this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
            this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);

            this.$el.find('.js_add_exchange, .btn_cancel').hover(
                function () {
                    $(this).attr('style', $(this).data('hover-style'));
                },
                function () {
                    $(this).attr('style', $(this).data('style'));
                }
            );
        },
        contentLoaded: function (data, status, xhr) {
            if (data == 'error') {
                new DialogMessage({
                    'title': Lang.get('frontend.errormsg.exchange.loadingerror'),
                    keyboardEnabled: true
                }, {
                    'closeTimeout': 1200
                }).handle();

                this.close();
                return false;
            } else {
                this.setContent(data);
                if (this.$content.find('.swiper_exchange .js_product_images_slider').length > 0) {
                    initSwiperImage();
                }

                contentLoadedAfter(this);
                recordUserViewTrack(pointProductPopup, exchangeDetailAjaxUrl, {
                    'product_id': Number(productId),
                    'standard_id': Number(standardId),
                });
            }


        },
    });
}
